<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.updateProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="preview-container text-center my-3">
            <img
              :src="data.image.path"
              alt="Product Image"
              v-if="data.image.path"
            />
          </div>
          <!-- End:: Image Upload Input -->

          <!-- End:: Image Upload Input -->

          <!-- <BaseImageUploadInput @file-selected="handleFileSelected" @file-removed="handleFileRemoved" /> -->

          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codenameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProd')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProdEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.product_price')"
            v-model.trim="data.price"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.quantity')"
            v-model.trim="data.quantity"
            disabled
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.expire_date_from')"
            v-model.trim="data.expire_date_from"
            disabled
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.expire_date_to')"
            v-model.trim="data.expire_date_to"
            disabled
          />
          <base-select-input
            col="6"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.section')"
            v-model.trim="data.section"
            disabled
          />
          <base-select-input
            col="5"
            :optionsList="pranches"
            multiple
            :placeholder="$t('PLACEHOLDERS.pranches')"
            v-model.trim="data.pranches"
            disabled
          />
          <a-tooltip
            v-if="pranches.length == 0"
            class="col-1"
            placement="bottom"
          >
            <template slot="title">
              <span>{{ $t("PLACEHOLDERS.add_pranch") }}</span>
            </template>
            <button type="button" class="btn_edit" @click="addBranches()">
              <i class="fas fa-code-branch"></i>
            </button>
          </a-tooltip>
          <!-- End:: Name Input -->

          <v-container>
            <v-row v-for="(box, index) in boxes" :key="index" align="center">
              <!-- <v-col cols="12" class="text-right">
                <v-btn icon color="primary" @click="addBox">
                  <i class="fas fa-plus"></i>
                </v-btn>

                <v-btn
                  icon
                  color="red"
                  v-if="boxes.length > 1"
                  @click="removeBox(index)"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
              </v-col> -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.condiction_ar')"
                v-model="box.condiction_ar"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.condiction_en')"
                v-model="box.condiction_en"
                disabled
              />
              <v-divider class="my-4"></v-divider>
            </v-row>
          </v-container>

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              disabled
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowProduct",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        price: null,
        quantity: null,
        expire_date_from: null,
        expire_date_to: null,
        section: null,
        pranches: null,
        provider_name: null,
        active: null,
      },
      boxes: [
        {
          condiction_ar: "",
          condiction_en: "",
        },
      ],
      // End:: Data Collection To Send
      pranches: [],
      categories: [],
      subCats: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    addBox() {
      this.boxes.push({
        condiction_ar: "",
        condiction_en: "",
      });
    },
    removeBox(index) {
      if (this.boxes.length > 1) {
        this.boxes.splice(index, 1);
      }
    },
    async getCats() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.categories = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getPranches() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `branches?page=0&limit=0`,
        });
        // console.log("products =>", res.data.data);
        this.pranches = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `products/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.Product.image;
        this.data.name = res.data.data.Product.name_ar;
        this.data.nameEn = res.data.data.Product.name_en;
        this.data.descProd = res.data.data.Product.description_ar;
        this.data.descProdEn = res.data.data.Product.description_en;
        this.data.price = res.data.data.Product.price;
        this.data.quantity = res.data.data.Product.quantity;
        this.data.expire_date_from = res.data.data.Product.start_date;
        this.data.expire_date_to = res.data.data.Product.end_date;
        this.data.provider_name = res.data.data.Product.provider_name;
        this.data.section = {
          id: res.data.data.Product.category_id,
          name: res.data.data.Product.category,
        };
        this.data.pranches = res.data.data.Product.branches;
        this.boxes = res.data.data.Product.usage_conditions?.map((ele) => ({
          condiction_ar: ele.ar,
          condiction_en: ele.en,
        }));
        this.data.active = res.data.data.Product.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    this.getCats();
    this.getPranches();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
